<template>
    <div class="blackjack">

        <!-- 🔒 PORTRAIT LOCK OVERLAY -->
        <div v-if="showRotateOverlay" class="rotate-overlay">
            <div class="rotate-box">
                <img src="@/assets/img/rotate-phone.svg" alt="Rotate device" />
                <h2>Turn the Phone Sideways</h2>
                <p>To play Rivo blackjack, position your device horizontally.</p>
            </div>
        </div>

        <!-- 🎮 GAME -->
        <transition name="slide-fade">
  <router-view v-show="!showRotateOverlay" />
</transition>

    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    name: 'Blackjack',
    metaInfo: {
        title: 'Blackjack - Rivobit.com'
    },
    data() {
        return {
            showRotateOverlay: false
        };
    },
    methods: {
        ...mapActions([
            'socketConnectBlackjack',
            'socketDisconnectBlackjack'
        ]),

        checkOrientation() {
            const isMobile = window.innerWidth <= 1024;
            const isPortrait = window.innerHeight > window.innerWidth;

            this.showRotateOverlay = isMobile && isPortrait;
        }
    },
    created() {
        this.checkOrientation();
        window.addEventListener('resize', this.checkOrientation);
        window.addEventListener('orientationchange', this.checkOrientation);

        this.socketConnectBlackjack();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkOrientation);
        window.removeEventListener('orientationchange', this.checkOrientation);
    },
    beforeRouteLeave(to, from, next) {
        this.socketDisconnectBlackjack();
        next();
    }
};
</script>


<style scoped>
.blackjack {
    width: 100%;
   
    position: relative;
    overflow: hidden;
}

/* TRANSITION */
.blackjack .slide-fade-enter-active {
    transition: all .3s ease-out;
}

.blackjack .slide-fade-enter {
    opacity: 0;
}

/* 🔒 ROTATE OVERLAY */
.rotate-overlay {
    position: fixed;
    inset: 0;
    background: radial-gradient(circle at center, #02231d, #000);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
}

.rotate-box {
    text-align: center;
    color: #ffffff;
    padding: 30px;
    max-width: 320px;
}

.rotate-box img {
    width: 120px;
    margin-bottom: 25px;
    opacity: 0.9;
}

.rotate-box h2 {
    font-size: 22px;
    font-weight: 800;
    margin-bottom: 10px;
}

.rotate-box p {
    font-size: 14px;
    opacity: 0.8;
}
</style>
